import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './i18n.tsx'
import 'vite/modulepreload-polyfill'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

const root = document.getElementById('root')!

const handleRouteError = (error: Error) => {
  console.error('Router error:', error)
}

const renderApp = () => (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
)

try {
  if (root.hasChildNodes()) {
    ReactDOM.hydrateRoot(root, renderApp())
  } else {
    ReactDOM.createRoot(root).render(renderApp())
  }
} catch (error) {
  handleRouteError(error as Error)
}
